import { DASH_META_ROOT, getAuthDashMetaCsrfToken } from '@revelio/auth';

import type { ReplotsChartName } from '../components/SharedReport/SharedReportDataContext';
import {
  DashMetaRateLimitError,
  parseRetryAfterSeconds,
} from './dash-meta-rate-limit-error';

interface CreateSharedPlotPayload {
  title: string;
  component: ReplotsChartName;
  props: Record<string, unknown>;
}

interface CreateSharedPlotResponse {
  token: string;
}

export interface SharedPlotSnapshot {
  token: string;
  title: string;
  component: ReplotsChartName;
  props: Record<string, unknown>;
  created: string;
}

export const createSharedPlot = async (
  payload: CreateSharedPlotPayload
): Promise<CreateSharedPlotResponse> => {
  const csrfToken = getAuthDashMetaCsrfToken();

  const response = await fetch(`${DASH_META_ROOT}/api/shared-plots`, {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      'x-surf-token-dash-meta': csrfToken ?? '',
    },
    body: JSON.stringify(payload),
  });

  if (response.status === 429) {
    throw new DashMetaRateLimitError(parseRetryAfterSeconds(response));
  }

  if (!response.ok) {
    throw new Error('Failed to create shared plot');
  }

  return response.json();
};

export const getSharedPlot = async (
  token: string
): Promise<SharedPlotSnapshot> => {
  const response = await fetch(`${DASH_META_ROOT}/api/shared-plots/${token}`);

  if (response.status === 429) {
    throw new DashMetaRateLimitError(parseRetryAfterSeconds(response));
  }

  if (!response.ok) {
    throw new Error('Shared plot not found');
  }

  return response.json();
};
